import React, { cloneElement } from 'react';
import { Check, ChevronRight, BookOpen, Droplet, Calculator, Package, Calendar, Smartphone, Coffee, Gift, ShoppingBag, Star, X } from 'lucide-react';
import { FAQ } from './components/FAQ';
export function App() {
  return <div className="min-h-screen bg-[#F7F1E8] font-['Inter',sans-serif] text-[#5A3A28] selection:bg-[#E8B3C1] selection:text-[#5A3A28]" data-id="element-0">
      {/* 1. HERO SECTION */}
      <section id="hero" className="relative py-8 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1">
        <div className="flex-1 z-10 w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-2">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#EF9F27] text-white font-semibold text-sm mb-8 shadow-sm" data-id="element-3">
            <span data-id="element-4">🔥 Precio de lanzamiento — Solo por tiempo limitado</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.1] text-[#5A3A28]" data-id="element-5">
            EMPRENDÉ CON MINICOOKIES DESDE TU CASA
          </h1>

          <p className="text-lg sm:text-xl text-[#5A3A28]/80 mb-8 font-medium leading-relaxed" data-id="element-6">
            Aprendé a producir, presentar y vender minicookies irresistibles con
            una app interactiva lista para usar.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-7">
            {['Recetas probadas', 'Costos y precios sugeridos', 'Packaging recomendado', 'Plan para conseguir tus primeras ventas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium" data-id="element-8">
                <div className="bg-[#C98A4B] rounded-full p-1" data-id="element-9">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-10" />
                </div>
                {item}
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-11">
            <button className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#5A3A28] hover:bg-[#4a2f20] text-white rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-12">
              QUIERO ACCEDER AHORA
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-13" />
            </button>
            <a href="#que-incluye" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-[#5A3A28]/5 text-[#5A3A28] rounded-full font-bold text-lg transition-all duration-300 border-2 border-[#5A3A28]/20 hover:border-[#5A3A28]" data-id="element-14">
              VER TODO LO QUE INCLUYE
            </a>
          </div>

          <p className="mt-5 text-sm font-semibold text-[#5A3A28]" data-id="element-15">
            $16.990 · o 3 cuotas de $5.663 sin interés con Mercado Pago 💳
          </p>
          <p className="mt-1 text-sm text-[#5A3A28]/70 font-medium" data-id="element-16">
            🔒 Acceso inmediato · De por vida · Sin suscripción
          </p>
        </div>

        <div className="flex-1 relative w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-17">
          <div className="absolute inset-0 bg-[#E8B3C1]/20 rounded-[2.5rem] transform rotate-3 scale-105 -z-10" data-id="element-18"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7Qsv58MeAQsJJ5h3eAKBBH/ChatGPT_Image_17_jun_2026,_07_48_28_p.m..png" alt="Minicookies Premium Mockup" className="rounded-[2.5rem] shadow-2xl object-cover w-full h-auto aspect-[4/5] lg:aspect-square" data-id="element-19" />
        </div>
      </section>

      {/* 2. QUÉ INCLUYE */}
      <section id="que-incluye" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white" data-id="element-20">
        <div className="max-w-[1400px] mx-auto" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-22">
            ¿QUÉ INCLUYE MINICOOKIES LAB?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-23">
            {[{
            icon: <BookOpen data-id="element-24" />,
            title: 'Recetas Premium',
            desc: 'Fórmulas exactas para cookies perfectas.'
          }, {
            icon: <Droplet data-id="element-25" />,
            title: 'Salsas para Dipping',
            desc: 'Complementos irresistibles para tus ventas.'
          }, {
            icon: <Calculator data-id="element-26" />,
            title: 'Costos y Precios',
            desc: 'Calculadora automática de rentabilidad.'
          }, {
            icon: <Package data-id="element-27" />,
            title: 'Packaging y Conservación',
            desc: 'Presentaciones que enamoran a tus clientes.'
          }, {
            icon: <Calendar data-id="element-28" />,
            title: 'Planner de Producción',
            desc: 'Organización paso a paso para escalar.'
          }, {
            icon: <Smartphone data-id="element-29" />,
            title: 'App Interactiva',
            desc: 'Todo tu negocio en la palma de tu mano.'
          }].map((item, i) => <div key={i} className="bg-[#F7F1E8] p-8 rounded-3xl border border-[#5A3A28]/10 hover:border-[#C98A4B] transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-30">
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#C98A4B] mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-31">
                  {cloneElement(item.icon, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-32">{item.title}</h3>
                <p className="text-[#5A3A28]/70 font-medium" data-id="element-33">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* COMPARATIVA: NO ES OTRO PDF */}
      <section id="comparativa" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#E8B3C1]/10" data-id="element-34">
        <div className="max-w-[1000px] mx-auto text-center" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-[#5A3A28]" data-id="element-36">
            No es otro PDF
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium mb-12" data-id="element-37">
            Es una herramienta interactiva diseñada para ayudarte a vender.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-38">
            {/* PDF */}
            <div className="bg-white p-8 rounded-3xl border border-[#5A3A28]/10 opacity-70" data-id="element-39">
              <h3 className="text-xl font-bold mb-6 text-[#5A3A28]/60" data-id="element-40">
                PDF tradicional
              </h3>
              <ul className="space-y-4" data-id="element-41">
                {['Información dispersa', 'Solo lectura', 'Sin herramientas', 'Difícil de consultar mientras trabajás'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#5A3A28]/70 font-medium" data-id="element-42">
                    <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-43" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Minicookies Lab */}
            <div className="bg-[#5A3A28] p-8 rounded-3xl shadow-xl text-[#F7F1E8] transform md:-translate-y-2" data-id="element-44">
              <h3 className="text-xl font-bold mb-6 text-[#EF9F27]" data-id="element-45">
                Minicookies Lab
              </h3>
              <ul className="space-y-4" data-id="element-46">
                {['Todo organizado', 'Acceso inmediato desde celular', 'Calculadora incluida', 'Sistema paso a paso', 'Herramientas para vender'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-47">
                    <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-48" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="text-2xl font-extrabold text-[#5A3A28]" data-id="element-49">
            Más que recetas. Un sistema completo para emprender.
          </p>
        </div>
      </section>

      {/* 3. MIRÁ LA APP POR DENTRO */}
      <section id="app" className="py-8 px-0 overflow-hidden" data-id="element-50">
        <h2 className="sr-only" data-id="element-51">
          Mirá la app por dentro — todo lo que necesitás para emprender,
          organizado paso a paso
        </h2>
        <div className="m-0 p-0 overflow-hidden bg-black" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/sdPsykQ6HWFBv9BWR7coUf/ChatGPT_Image_22_jun_2026,_08_21_15_p.m..png" alt="Mirá la app por dentro: pantallas reales de recetas, primeras ventas y producción de la app Minicookies Lab" className="block w-full h-auto m-0 p-0 rounded-none border-0 shadow-none" data-id="element-53" />
        </div>
      </section>

      {/* CALCULADORA / GANANCIAS */}
      <section id="ganancias" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white" data-id="element-54">
        <div className="max-w-[1200px] mx-auto" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-[#5A3A28]" data-id="element-56">
            ¿Cuánto podrías generar?
          </h2>

          <div className="flex flex-col lg:flex-row items-center gap-12 bg-[#F7F1E8] rounded-[2.5rem] p-8 lg:p-12 border border-[#5A3A28]/10" data-id="element-57">
            <div className="flex-1 w-full" data-id="element-58">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C98A4B]/20 text-[#5A3A28] font-bold text-sm mb-6" data-id="element-59">
                <span data-id="element-60">🍪 Ejemplo real</span>
              </div>
              <h3 className="text-2xl font-bold mb-8 text-[#5A3A28]" data-id="element-61">
                10 vasos de minicookies por semana
              </h3>

              <div className="space-y-4 mb-8" data-id="element-62">
                <div className="flex justify-between items-center border-b border-[#5A3A28]/10 pb-4" data-id="element-63">
                  <span className="text-[#5A3A28]/70 font-medium" data-id="element-64">
                    Costo aproximado:
                  </span>
                  <span className="font-bold text-[#5A3A28]" data-id="element-65">$12.000</span>
                </div>
                <div className="flex justify-between items-center border-b border-[#5A3A28]/10 pb-4" data-id="element-66">
                  <span className="text-[#5A3A28]/70 font-medium" data-id="element-67">
                    Venta promedio:
                  </span>
                  <span className="font-bold text-[#5A3A28]" data-id="element-68">$35.000</span>
                </div>
                <div className="flex justify-between items-center pt-2" data-id="element-69">
                  <span className="text-xl font-bold text-[#5A3A28]" data-id="element-70">
                    Ganancia estimada:
                  </span>
                  <span className="text-2xl font-extrabold text-[#22c55e]" data-id="element-71">
                    $23.000
                  </span>
                </div>
              </div>

              <div className="bg-[#E8B3C1]/30 p-6 rounded-2xl mb-4" data-id="element-72">
                <p className="text-lg font-bold text-[#5A3A28] text-center" data-id="element-73">
                  Solo con una producción pequeña podrías generar más de{' '}
                  <span className="text-[#C98A4B]" data-id="element-74">$90.000 al mes</span>.
                </p>
              </div>
              <p className="text-xs text-center text-[#5A3A28]/60" data-id="element-75">
                Los resultados dependen de cada persona, precios y zona de
                venta.
              </p>
            </div>

            <div className="flex-1 w-full" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/eqV7WrxiDAbyTTcT2YWH1H/descarga_(10).jpg" alt="Bandeja de minicookies" className="w-full h-auto rounded-3xl shadow-lg object-cover aspect-square" data-id="element-77" />
            </div>
          </div>
        </div>
      </section>

      {/* 4. LO QUE PODÉS VENDER */}
      <section id="vender" className="py-8 px-6 lg:px-12 bg-white" data-id="element-78">
        <div className="max-w-[1400px] mx-auto" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-80">
            LO QUE PODÉS VENDER
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-81">
            {[{
            title: 'Vasos de minicookies',
            desc: 'El formato estrella para consumo al paso.',
            icon: <Coffee className="w-6 h-6" data-id="element-82" />
          }, {
            title: 'Bandejas para compartir',
            desc: 'Ideales para reuniones y regalos.',
            icon: <ShoppingBag className="w-6 h-6" data-id="element-83" />
          }, {
            title: 'Souvenirs',
            desc: 'Para cumpleaños, bodas y eventos.',
            icon: <Gift className="w-6 h-6" data-id="element-84" />
          }, {
            title: 'Mesas dulces',
            desc: 'Propuestas premium para fiestas.',
            icon: <Star className="w-6 h-6" data-id="element-85" />
          }].map((item, i) => <div key={i} className="group relative rounded-3xl overflow-hidden aspect-square bg-[#F7F1E8] border border-[#5A3A28]/10 flex flex-col items-center justify-center p-8 text-center hover:bg-[#5A3A28] hover:text-white transition-colors duration-300" data-id="element-86">
                <div className="w-16 h-16 bg-white/50 rounded-full flex items-center justify-center text-[#C98A4B] mb-6 group-hover:bg-white/10 group-hover:text-[#E8B3C1] transition-colors" data-id="element-87">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-88">{item.title}</h3>
                <p className="opacity-80 font-medium" data-id="element-89">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. IDEAL PARA VOS SI... */}
      <section id="ideal" className="py-8 px-6 lg:px-12 relative" data-id="element-90">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/wnNrC9o8oofHrx9j3yxmfZ/ChatGPT_Image_18_jun_2026,_04_25_18_p.m..png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-91"></div>
        <div className="max-w-3xl mx-auto relative z-10 bg-white/90 backdrop-blur-md p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-[#5A3A28]/10" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-10 text-[#5A3A28]" data-id="element-93">
            IDEAL PARA VOS SI...
          </h2>

          <ul className="space-y-6" data-id="element-94">
            {['Querés generar ingresos desde casa', 'Te gusta la cocina y los detalles', 'Buscás un emprendimiento de baja inversión', 'Querés vender por Instagram y WhatsApp', 'Necesitás un sistema paso a paso comprobado'].map((text, i) => <li key={i} className="flex items-center gap-4 text-lg md:text-xl font-medium" data-id="element-95">
                <div className="bg-[#E8B3C1] rounded-full p-1 shrink-0" data-id="element-96">
                  <Check className="w-5 h-5 text-[#5A3A28]" strokeWidth={3} data-id="element-97" />
                </div>
                {text}
              </li>)}
          </ul>
        </div>
      </section>

      {/* AUTORIDAD */}
      <section id="autoridad" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white text-center" data-id="element-98">
        <div className="max-w-3xl mx-auto" data-id="element-99">
          <div className="w-16 h-16 bg-[#E8B3C1]/30 rounded-full flex items-center justify-center mx-auto mb-6 text-[#5A3A28]" data-id="element-100">
            <Star className="w-8 h-8 fill-current" data-id="element-101" />
          </div>
          <h2 className="text-3xl font-extrabold mb-6 text-[#5A3A28]" data-id="element-102">
            Creada para emprendedoras reales
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium leading-relaxed" data-id="element-103">
            Pensada para quienes quieren comenzar desde casa con baja inversión,
            vender por Instagram, WhatsApp, ferias o pedidos personalizados y
            transformar una receta en un negocio.
          </p>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <FAQ data-id="element-104" />

      {/* URGENCY BAND */}
      <section id="lanzamiento" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#EF9F27] text-[#5A3A28] text-center" data-id="element-105">
        <div className="max-w-4xl mx-auto" data-id="element-106">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4 flex items-center justify-center gap-2" data-id="element-107">
            🔥 Precio de lanzamiento
          </h2>
          <p className="text-lg font-bold" data-id="element-108">
            Acceso de por vida. Actualizaciones futuras incluidas.{' '}
            <br className="hidden md:block" data-id="element-109" />
            <span className="font-medium opacity-90" data-id="element-110">
              El valor aumentará cuando se agreguen nuevos módulos y
              herramientas.
            </span>
          </p>
        </div>
      </section>

      {/* 6. OFERTA */}
      <section id="oferta" className="py-8 px-6 lg:px-12 bg-[#5A3A28] text-[#F7F1E8]" data-id="element-111">
        <div className="max-w-4xl mx-auto text-center" data-id="element-112">
          <div className="inline-block bg-[#EF9F27] text-[#5A3A28] px-6 py-2 rounded-full font-bold tracking-widest text-sm mb-8 uppercase" data-id="element-113">
            ⭐ Oferta de lanzamiento
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-114">
            Empezá esta semana
          </h2>

          <div className="flex flex-col items-center mb-12" data-id="element-115">
            <span className="text-2xl text-[#F7F1E8]/50 line-through font-medium" data-id="element-116">
              $24.990
            </span>
            <span className="text-5xl md:text-6xl font-extrabold text-white mt-1" data-id="element-117">
              $16.990
            </span>
            <span className="text-base text-[#F7F1E8]/80 font-medium mt-3" data-id="element-118">
              o 3 cuotas de $5.663 sin interés con Mercado Pago
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/k8sZQSvD3uyxpXfrvPiUcq/descarga_(2).png" alt="Mercado Pago" className="h-7 w-auto mt-2 bg-white rounded-md px-2 py-1" data-id="element-119" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-4 text-left max-w-xl mx-auto mb-12" data-id="element-120">
            {['Recetas probadas', 'Calculadora de costos', 'Packaging recomendado', 'Plan para primeras ventas', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-121">
                <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-122" />
                <span className="font-medium text-lg" data-id="element-123">{item}</span>
              </div>)}
          </div>

          <button className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-10 py-5 bg-[#EF9F27] hover:bg-[#d98e1f] text-[#5A3A28] rounded-full font-extrabold text-xl transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-124">
            QUIERO ACCEDER AHORA
            <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-125" />
          </button>

          <p className="mt-6 text-sm text-[#F7F1E8]/70 font-medium" data-id="element-126">
            Acceso de por vida • Sin suscripciones • Disponible desde cualquier
            dispositivo
          </p>
        </div>
      </section>
    </div>;
}